const UserPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    UPDATE_PHONE_NUMBER: 'update-phone-number',
    UPDATE_EMAIL: 'update-email',
    UPDATE_PIN: 'update-pin',
    CHANGE_PASSWORD: 'change-password',
    DELETE: 'delete',
}

const RolePermission = {
    LIST: 'list',
    LIST_PERMISSION: 'list-permission',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const UserAddressPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const SettingPermission = {
    LIST: 'list',
    UPDATE: 'update'
}

const SystemSettingPermission = {
    LIST: 'list',
    UPDATE: 'update'
}

const PushNotificationPermission = {
    LIST: 'list',
    CREATE: 'create'
}

const ComplaintPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create'
}

const RecoveryPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update'
}

const EmergencyContactPermission = {
    LIST: 'list',
    READ: 'read',
    DEFAULT: 'default',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const DriverVehiclePermission = {
    LIST: 'list',
    LIST_OWN: 'list-own',
    READ: 'read',
    CREATE: 'create',
    DELETE: 'delete',
    APPROVAL: 'approval',
}

const VehicleTypePermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const FarePermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const OrderPermission = {
    LIST: 'list',
    LIST_OWN: 'list-own',
    READ: 'read',
    CREATE: 'create',
    UPDATE_STATUS: 'update-status',
}

const BannerPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const DashboardPermission = {
    READ: 'read',
    SALE: 'sale',
    TOP_UP: 'top-up',
    PROFIT: 'profit',
    USER: 'user',
    RIDE: 'ride',
    DRIVER: 'driver',
    CUSTOMER: 'customer',
    CANCEL: 'cancel',
}

const VideoPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const DriverApplicationPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE_STATUS: 'update-status',
}

const QuizPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete'
}

const WithdrawalPermission = {
    LIST: 'list',
    LIST_OWN: 'list-own',
    READ: 'read',
    CREATE: 'create',
    UPDATE_STATUS: 'update-status',
}

const AdminPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const DriverPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const TransactionPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

const DriverTierPermission = {
    LIST: 'list',
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    ASSIGN: 'assign',
}

export {
    UserPermission,
    RolePermission,
    UserAddressPermission,
    SettingPermission,
    SystemSettingPermission,
    PushNotificationPermission,
    ComplaintPermission,
    RecoveryPermission,
    EmergencyContactPermission,
    DriverVehiclePermission,
    VehicleTypePermission,
    FarePermission,
    OrderPermission,
    BannerPermission,
    VideoPermission,
    DriverApplicationPermission,
    QuizPermission,
    DashboardPermission,
    WithdrawalPermission,
    AdminPermission,
    DriverPermission,
    TransactionPermission,
    DriverTierPermission,
}